import { render, staticRenderFns } from "./FilialRelatorio.vue?vue&type=template&id=8dc19e62"
import script from "./FilialRelatorio.vue?vue&type=script&lang=js"
export * from "./FilialRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports